import { all, put, retry } from 'redux-saga/effects';
import isPostcodeMatchingForSubcategoryQuery from './isPostcodeMatchingForSubcategoryQuery';
import isPostcodeBlockingSubmissionQuery from './isPostcodeBlockingSubmission';
import { ComponentTypes } from '../../../../Data/Components';
import { SUBCATEGORY_IDS_WITH_POSTCODE_CONSTRAINTS } from '../../../../Data/Constants';

const TWO_SECONDS = 2000;

export function* checkPostcodeAgainstSubcategory({
  postcode,
  components,
  subcategoryId,
}) {
  const supplierCardComponentPages = Object.values(components)
    .filter((c) => c.component.type === ComponentTypes.SUPPLIER_CARD)
    .map((c) => c.component.page);

  const componentsDependentOnPostcodeMatching = Object.values(
    components
  ).filter((c) => supplierCardComponentPages.includes(c.component.page));
  // Determine whether the postcode should result in supplier cards being hidden
  try {
    const args = {
      postcode: postcode || '',
      subcategoryId,
    };
    const isPostcodeMatchingForSubcategory = yield retry(
      3,
      TWO_SECONDS,
      isPostcodeMatchingForSubcategoryQuery,
      args
    );
    yield all(
      componentsDependentOnPostcodeMatching.map((c) =>
        put({
          type: 'COMPONENTS/setCondition',
          payload: {
            componentId: c.component.id,
            condition: 'requiresPostcodeToNotMatch',
            value: {
              isMatching: isPostcodeMatchingForSubcategory,
            },
          },
        })
      )
    );
  } catch (error) {
    // If the request fails for any reason then we will assume that the postcode is valid.
    yield all(
      componentsDependentOnPostcodeMatching.map((c) =>
        put({
          type: 'COMPONENTS/setCondition',
          payload: {
            componentId: c.component.id,
            condition: 'requiresPostcodeToNotMatch',
            value: {
              isMatching: true,
            },
          },
        })
      )
    );
  }
}

export function* checkIsPostcodeBlockingSubmission({ postcode, formConfig }) {
  const { subcategoryCountryCode, sectorName } = formConfig;
  if (!subcategoryCountryCode || !sectorName) {
    return false;
  }

  try {
    const isPostcodeBlockingSubmission = yield retry(
      3,
      TWO_SECONDS,
      isPostcodeBlockingSubmissionQuery,
      {
        postcode,
        subcategoryCountryCode,
        sectorName,
      }
    );
    return isPostcodeBlockingSubmission;
  } catch (error) {
    return true;
  }
}

export function* isPostcodeBlockedForSubcategory({ postcode, subcategoryId }) {
  if (!SUBCATEGORY_IDS_WITH_POSTCODE_CONSTRAINTS.includes(subcategoryId)) {
    return false;
  }

  try {
    const isMatching = yield retry(
      3,
      TWO_SECONDS,
      isPostcodeMatchingForSubcategoryQuery,
      { postcode, subcategoryId }
    );
    return !isMatching;
  } catch (error) {
    return false;
  }
}
